export class OperatorDocument {
  fileName: string;
  url: string;
  status: string;
  docTypeId: number;
  operatorDocumentId: string;
}
